export default __webpack_public_path__ + "static/media/icon-vaccine.be6c25af.svg";